import Layout from '@components/layout';
import { routes } from '@router/index';
import { RootState } from '@utils/types';
import { Spinner } from 'flowbite-react';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { segmentCode = '' } = useSelector((state: RootState) => state.user);
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex h-screen w-screen">
            <div className="m-auto">
              <Spinner color="info" />
            </div>
          </div>
        }
      >
        <div className="min-h-screen w-screen overflow-x-hidden bg-gray-100">
          <Routes>
            {routes
              .filter((route) => route.isProtected === false)
              .map((route) => (
                <Route
                  path={route.path}
                  key={route.key}
                  element={route.element}
                />
              ))}
            <Route element={<Layout />}>
              {routes
                .filter((route) => route.isProtected === true)
                .filter((route) => {
                  let check = true;
                  if (
                    route?.excludedRoles &&
                    segmentCode !== '' &&
                    route.excludedRoles.includes(segmentCode)
                  ) {
                    check = false;
                  }
                  return check;
                })
                .map((route) => (
                  <Route
                    path={route.path}
                    key={route.key}
                    element={route.element}
                  />
                ))}
            </Route>
          </Routes>
        </div>
        <ToastContainer />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
